import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';
import {Pagination} from 'src/app/domain/search/Pagination';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {CmisService} from 'src/app/modules/services/cmis/cmis.service';
import {FaqService} from 'src/app/modules/services/faq/faq.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-faq-card',
    templateUrl: './faq-card.component.html',
    styleUrls: ['./faq-card.component.css']
})
export class FaqCardComponent implements OnInit {
    @ViewChild('frContainer', {static: true}) frContainer: ElementRef;

    public searchObject = new SearchObject();
    public pagination: Pagination = new Pagination();
    public fileitems: any[];
    public dataSearch: Array<CriteriaSearch> = [];
    public criteriaSearch: CriteriaSearch = new CriteriaSearch('fileClCd', '07', '=');
    criteriaSearch2: CriteriaSearch;
    public id = null;
    public item: any;
    public current_lang = this.translate.getDefaultLang();

    constructor(
        private cmisService: CmisService,
        private route: ActivatedRoute,
        private faqService: FaqService,
        private translate: AppTranslateService,
        private translateS: TranslateService
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;

        });
    }

    ngOnInit(): void {

        this.route.queryParams.subscribe(params => {
            this.id = params.id;


        });
        this.loadcard();
    }

    loadcard() {
        {

            this.faqService.loadcard(this.id)
                .subscribe(response => {

                    this.item = response['payload'];
                    this.frContainer.nativeElement.innerHTML = this.item.cont1;

                    this.loadfiles(this.item.seqno);


                });
        }

    }

    loadfiles(sequenceNumber) {

        this.criteriaSearch2 = new CriteriaSearch('seqno', sequenceNumber, '=');
        this.dataSearch.push(this.criteriaSearch2);
        this.dataSearch.push(this.criteriaSearch);
        this.pagination.limit = 1000;
        this.pagination.offSet = 0;
        this.searchObject.pagination = this.pagination;
        this.searchObject.dataSearch = this.dataSearch;

        this.cmisService.loadFiles(this.searchObject)
            .subscribe(response => {

                this.fileitems = response['payload'].data;



            });
    }


}
